import React from "react";
import { dataTypes } from "../../dataTypes";
import "../../../css/utility.scss";

const Selector = React.memo(
  ({
    dataType,
    role,
    onHandleChangeDatatype,
    disabled,
    isNewAddedByPreOrPro,
  }) => {
    return (
      <select
        className="w-100"
        value={dataType ? dataType : ""}
        onChange={onHandleChangeDatatype}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        disabled={
          role === "processor"
            ? false
            : isNewAddedByPreOrPro
              ? false
              : role !== "preProcessor" || disabled
        }
      >
        <option value="">
          <em>Datatype</em>
        </option>
        {dataTypes.map((item, index) => {
          return (
            <option value={item?.value} key={item?.value}>
              {item.type}
            </option>
          );
        })}
      </select>
    );
  },
);

const DataTypeSelector = ({
  parameterData,
  onHandleChangeDatatype,
  parameterIndex,
  role,
  isDataRejectedByProcessor,
  entireBatchRejectedByPro,
  isDataRejectedByInvestigatorMappingValidator,
  entireBatchRejectedByInvestigatorMappingValidator,
}) => {
  const isDisable = () => {
    let isDisable = false;

    /**
     * Processor rejection checks
     */
    if (!entireBatchRejectedByPro && isDataRejectedByProcessor) {
      const isAnyProcessorCellRejected = parameterData?.mappings?.some(
        (ele) => ele?.processorCellRejection?.isRejected,
      );

      isDisable =
        isAnyProcessorCellRejected ||
        parameterData?.processorRowRejection?.isRejected
          ? false
          : true;
    }

    /**
     * Investigator Mapping Validator rejection checks
     */
    if (
      !entireBatchRejectedByInvestigatorMappingValidator &&
      isDataRejectedByInvestigatorMappingValidator
    ) {
      const isAnyInvestigatorMappingCellRejected =
        parameterData?.mappings?.some(
          (ele) => ele?.investigatorMappingValidatiorCellRejection?.isRejected,
        );

      isDisable =
        isAnyInvestigatorMappingCellRejected ||
        parameterData?.investigatorMappingValidatiorRowRejection?.isRejected
          ? false
          : true;
    }

    return isDisable;
  };

  return (
    <Selector
      dataType={parameterData?.dataType}
      isNewAddedByPreOrPro={
        role === "preProcessor"
          ? parameterData?.isNewAddedByPre
          : parameterData?.isNewAddedByPro
      }
      onHandleChangeDatatype={(e) =>
        onHandleChangeDatatype(
          e.target.value,
          parameterData?.parameter,
          parameterIndex,
        )
      }
      parameter={parameterData?.parameterData}
      role={role}
      parameterIndex={parameterIndex}
      disabled={isDisable()}
    />
  );
};

export default DataTypeSelector;
